import React from "react";
import {
  FeaturesCardContainer,
  FeaturesContainer,
  TextContainer,
  TitleContainer,
} from "./index.styled";
import AvanegarFeaturesCard from "../featuresAvanegarCard";
import icon1 from "../../assets/images/01.svg";
import icon2 from "../../assets/images/02.png";
import icon3 from "../../assets/images/03.svg";
import icon4 from "../../assets/images/04.svg";
import icon5 from "../../assets/images/05.svg";
import icon6 from "../../assets/images/06.svg";

const text = (
  <>
    <span>توانایی تبدیل گفتار </span> <br /> <span> محاوره و رسمی</span>
  </>
);

const AvanegarFeatures = () => {
  const FeaturesItem = [
    {
      id: 1,
      icon: icon1,
      content: (
        <>
          <span>توانایی تبدیل گفتار </span> <br /> <span> محاوره و رسمی</span>
        </>
      ),
    },
    {
      id: 2,
      icon: icon2,
      content: (
        <>
          <span>شناسایی دقیق کلمات </span> <br /> <span> با دقت انسانی</span>
        </>
      ),
    },
    {
      id: 3,
      icon: icon3,
      content: (
        <>
          <span>فیلترکردن واژگان دلخواه </span> <br />{" "}
          <span> از سوی کاربر</span>
        </>
      ),
    },
    {
      id: 4,
      icon: icon4,
      content: (
        <>
          <span>تبدیل گفتار به متن </span> <br />{" "}
          <span> در محیط‌های پرسروصدا</span>
        </>
      ),
    },
    {
      id: 5,
      icon: icon5,
      content: (
        <>
          <span>تشخیص تمامی لهجه‌های </span> <br />{" "}
          <span> بومی ایرانی و فارسی</span>
        </>
      ),
    },
    {
      id: 6,
      icon: icon6,
      content: (
        <>
          <span>تشخیص و تمیز دادن </span> <br />{" "}
          <span> گویندگان متفاوت از هم</span>
        </>
      ),
    },
  ];
  return (
    <FeaturesContainer className="container" id="features">
      <TitleContainer color="#12A46F" titleColor="#8C8D9B" textColor="#2D3134">
        <h5>ویژگی ها</h5>
        <TextContainer width="352px">
          <span></span>
          <p>ویـژگـی‌هـای منحصر بفردی که سرویس آوانـگار را متمایز می‌کند.</p>
        </TextContainer>
      </TitleContainer>
      <FeaturesCardContainer>
        {FeaturesItem.map((item) => (
          <AvanegarFeaturesCard key={item.id} features={item} />
        ))}
      </FeaturesCardContainer>
    </FeaturesContainer>
  );
};

export default AvanegarFeatures;
